interface TextSummaryChartProps {
  textSummary: string;
}

export const TextSummaryChart: React.FC<TextSummaryChartProps> = ({
  textSummary,
}) => {
  return (
    <div>
      {textSummary ? (
        <p className="mt-8 text-sm italic border border-slate-500 p-4 bg-slate-700">
          {textSummary}
        </p>
      ) : (
        <p className="text-slate-400">No data</p>
      )}
    </div>
  );
};
